import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/lib/pwa";

// Benign ResizeObserver loop notifications must never trip the CRA dev
// overlay (it covers the whole viewport during Founder UAT on preview).
const RO_MSG = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (RO_MSG.test(e.message || "")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
registerSW();
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
